  (function () {
    if (window.__zvQW) return;
    window.__zvQW = true;
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var KEY = 'zv_wishlist';
    var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path class="zv-heart" d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.2 3.4 4.8 6.8 4.6c2-.1 3.6 1 4.4 2.5.2.4.6.4.8 0 .8-1.5 2.4-2.6 4.4-2.5 3.4.2 5.3 3.6 4.1 6.7-1.8 4.6-8.5 9.2-8.5 9.2Z" stroke-linejoin="round"/></svg>';
    var EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';

    function money(c) { return 'Rs. ' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

    /* ---------- wishlist store ---------- */
    function getList() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
    function setList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} document.dispatchEvent(new CustomEvent('zv:wishlist', { detail: l })); }
    function has(h) { return getList().indexOf(h) > -1; }
    function toggle(h) { var l = getList(), i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.unshift(h); setList(l.slice(0, 100)); return i === -1; }
    window.ZevarWishlist = { get: getList, set: setList, has: has, toggle: toggle };

    function handleFrom(href) { try { var p = new URL(href, location.origin).pathname; var m = p.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; } }

    /* ---------- card buttons ---------- */
    function decorate(scope) {
      (scope || document).querySelectorAll('.card-wrapper:not([data-zv-ca])').forEach(function (w) {
        w.setAttribute('data-zv-ca', '1');
        var a = w.querySelector('a[href*="/products/"]');
        var inner = w.querySelector('.card__inner') || w.querySelector('.card');
        if (!a || !inner) return;
        var h = handleFrom(a.getAttribute('href'));
        if (!h) return;
        if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
        var box = document.createElement('div');
        box.className = 'zv-ca';
        box.innerHTML = '<button type="button" class="zv-ca__btn zv-ca__wish' + (has(h) ? ' is-active' : '') + '" data-zv-wish="' + esc(h) + '" aria-label="Add to wishlist" aria-pressed="' + has(h) + '">' + HEART + '</button>' +
          '<button type="button" class="zv-ca__btn zv-ca__qv" data-zv-qv="' + esc(h) + '" aria-label="Quick view">' + EYE + '</button>';
        inner.appendChild(box);
      });
    }

    function syncHearts() {
      var l = getList();
      document.querySelectorAll('[data-zv-wish]').forEach(function (b) {
        var on = l.indexOf(b.getAttribute('data-zv-wish')) > -1;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
        if (b.classList.contains('zv-pdp-wish')) { var sp = b.querySelector('span'), txt = on ? 'Saved to wishlist' : 'Add to wishlist'; if (sp && sp.textContent !== txt) sp.textContent = txt; }
      });
      var c = document.getElementById('ZvWishCount');
      if (c) { var n = String(l.length); if (c.textContent !== n) c.textContent = n; if (c.hidden !== !l.length) c.hidden = !l.length; }
    }
    document.addEventListener('zv:wishlist', syncHearts);
    window.addEventListener('storage', function (e) { if (e.key === KEY) syncHearts(); });

    /* ---------- header heart ---------- */
    function headerIcon() {
      if (document.getElementById('ZvWishIcon')) return;
      var cart = document.getElementById('cart-icon-bubble');
      if (!cart) return;
      var a = document.createElement('a');
      a.href = ROOT + 'pages/wishlist';
      a.id = 'ZvWishIcon';
      a.className = 'header__icon link focus-inset zv-wish-icon';
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = HEART + '<span class="zv-wish-count" id="ZvWishCount" hidden>0</span>';
      cart.parentNode.insertBefore(a, cart);
    }

    /* ---------- product page button ---------- */
    function pdpButton() {
      var h = handleFrom(location.href);
      if (!h || document.querySelector('.zv-pdp-wish')) return;
      var btns = document.querySelector('main product-form .product-form__buttons') || document.querySelector('main .product-form__buttons');
      if (!btns) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zv-pdp-wish';
      b.setAttribute('data-zv-wish', h);
      b.innerHTML = HEART + '<span>Add to wishlist</span>';
      btns.parentNode.insertBefore(b, btns.nextSibling);
    }

    /* ---------- quick view ---------- */
    var qv, lastFocus;
    function ensureModal() {
      if (qv) return qv;
      qv = document.createElement('div');
      qv.className = 'zv-qv';
      qv.hidden = true;
      qv.innerHTML = '<div class="zv-qv__overlay" data-zv-close></div><div class="zv-qv__dialog" role="dialog" aria-modal="true" aria-label="Quick view"><button type="button" class="zv-qv__close" data-zv-close aria-label="Close">&times;</button><div class="zv-qv__body" style="display:contents"></div></div>';
      document.body.appendChild(qv);
      qv.addEventListener('click', function (e) { if (e.target.closest('[data-zv-close]')) closeQV(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qv.hidden) closeQV(); });
      return qv;
    }
    function closeQV() { if (!qv) return; qv.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }

    function openQV(handle, trigger) {
      ensureModal();
      lastFocus = trigger;
      var body = qv.querySelector('.zv-qv__body');
      body.innerHTML = '<div class="zv-qv__loading">Loading…</div>';
      qv.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      qv.querySelector('.zv-qv__close').focus();
      fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) { renderQV(p, body); })
        .catch(function () { body.innerHTML = '<div class="zv-qv__loading">Could not load this product. <a href="' + ROOT + 'products/' + encodeURIComponent(handle) + '">Open product page</a></div>'; });
    }

    function renderQV(p, body) {
      var imgs = (p.images || []).slice(0, 8);
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var multi = p.variants.length > 1;
      body.innerHTML =
        '<div class="zv-qv__media">' +
          (imgs.length ? '<img class="zv-qv__main" src="' + img(imgs[0], 900) + '" alt="' + esc(p.title) + '">' : '') +
          (imgs.length > 1 ? '<div class="zv-qv__thumbs">' + imgs.map(function (u, i) { return '<img src="' + img(u, 160) + '" data-full="' + img(u, 900) + '" alt="" class="' + (i ? '' : 'is-active') + '" loading="lazy">'; }).join('') + '</div>' : '') +
        '</div>' +
        '<div class="zv-qv__info">' +
          '<h2 class="zv-qv__title">' + esc(p.title) + '</h2>' +
          '<div class="zv-qv__price"></div>' +
          (multi ? '<div><label class="zv-qv__label" for="ZvQvVariant">Option</label><select class="zv-qv__select" id="ZvQvVariant">' + p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' – Sold out') + '</option>'; }).join('') + '</select></div>' : '') +
          '<div class="zv-qv__row"><div class="zv-qv__qty"><button type="button" data-q="-1" aria-label="Decrease">−</button><input type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-q="1" aria-label="Increase">+</button></div>' +
          '<button type="button" class="zv-qv__add">Add to cart</button></div>' +
          '<div class="zv-qv__msg" role="status"></div>' +
          '<div class="zv-qv__links"><a class="zv-qv__full" href="' + p.url + '">View full details →</a>' +
          '<button type="button" class="zv-pdp-wish' + (has(p.handle) ? ' is-active' : '') + '" data-zv-wish="' + esc(p.handle) + '" style="margin:0">' + HEART + '<span>' + (has(p.handle) ? 'Saved to wishlist' : 'Add to wishlist') + '</span></button></div>' +
        '</div>';
      var main = body.querySelector('.zv-qv__main');
      body.querySelectorAll('.zv-qv__thumbs img').forEach(function (t) {
        t.addEventListener('click', function () { main.src = t.dataset.full; body.querySelectorAll('.zv-qv__thumbs img').forEach(function (x) { x.classList.toggle('is-active', x === t); }); });
      });
      var priceEl = body.querySelector('.zv-qv__price'), addBtn = body.querySelector('.zv-qv__add'), qty = body.querySelector('.zv-qv__qty input'), msg = body.querySelector('.zv-qv__msg');
      function show(variant) {
        v = variant;
        var off = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
        priceEl.innerHTML = '<span class="zv-qv__now">' + money(variant.price) + '</span>' + (off ? '<span class="zv-qv__was">' + money(variant.compare_at_price) + '</span><span class="zv-qv__off">' + off + '% OFF</span>' : '');
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (variant.featured_image && main) main.src = img(variant.featured_image.src, 900);
      }
      show(v);
      var sel = body.querySelector('#ZvQvVariant');
      if (sel) sel.addEventListener('change', function () { var nv = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; if (nv) show(nv); });
      body.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.q, 10)); }); });
      addBtn.addEventListener('click', function () {
        if (!v || !v.available) return;
        addBtn.disabled = true; addBtn.textContent = 'Adding…'; msg.textContent = '';
        var drawer = document.querySelector('cart-drawer');
        var payload = { items: [{ id: v.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] };
        if (drawer && typeof drawer.getSectionsToRender === 'function') { payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); payload.sections_url = location.pathname; }
        fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
          .then(function (res) {
            closeQV();
            addBtn.disabled = false; addBtn.textContent = 'Add to cart';
            if (drawer && res.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); res.id = v.id; drawer.renderContents(res); }
            else location.href = window.routes.cart_url;
          })
          .catch(function (err) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; msg.textContent = (err && err.description) || 'Something went wrong, please try again.'; });
      });
    }

    /* ---------- events ---------- */
    document.addEventListener('click', function (e) {
      var w = e.target.closest('[data-zv-wish]');
      if (w) { e.preventDefault(); e.stopPropagation(); toggle(w.getAttribute('data-zv-wish')); return; }
      var q = e.target.closest('[data-zv-qv]');
      if (q) { e.preventDefault(); e.stopPropagation(); openQV(q.getAttribute('data-zv-qv'), q); }
    }, true);

    function init() {
      decorate(document);
      headerIcon();
      pdpButton();
      syncHearts();
      var pending = false;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (!muts[i].addedNodes.length) continue;
          if (t.nodeType === 1 && t.closest && t.closest('.zv-ca, #ZvWishIcon, .zv-pdp-wish, .zv-qv')) continue;
          if (!pending) { pending = true; requestAnimationFrame(function () { pending = false; decorate(document); headerIcon(); syncHearts(); }); }
          break;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
